import { http } from "@/utils/http";
import { ICompanyFilter } from "@/features/company/company.types";
import { AxiosResponse } from "axios";
import { cleanParams } from "@/utils/cleanParams";

export const companyService = {
  getCompanies(filter?: ICompanyFilter): Promise<AxiosResponse> {
    return http.get("/companies", {
      params: cleanParams(filter),
    });
  },

  getSimpleCompanies(filter?: ICompanyFilter): Promise<AxiosResponse> {
    return http.get("/companies/simple", {
      params: cleanParams(filter),
    });
  },

  updateCompany(
    companyId: string,
    payload: { team_id: string }
  ): Promise<AxiosResponse> {
    return http.patch(`/companies/${companyId}/team`, payload);
  },

  bulkUpdateCompany(payload: {
    company_ids: string[];
    team_id: string;
  }): Promise<AxiosResponse> {
    return http.patch(`/companies/bulk/team`, payload);
  },

  addCompanyNote(
    companyId: string,
    payload: { note: string }
  ): Promise<AxiosResponse> {
    return http.put(`/companies/${companyId}/note`, payload);
  },

  taskCreationBlock(companyId: string, payload: any): Promise<AxiosResponse> {
    return http.patch(`/companies/${companyId}/task-creation-block`, payload);
  },

  truckDeactivation(companyId: string, payload: any): Promise<AxiosResponse> {
    return http.patch(`/companies/${companyId}/truck-deactivation`, payload);
  },
};
